var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPeoplemag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_11789)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1909_11789)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5405 37.9369C60.3264 37.9369 60.7369 37.198 60.9011 36.2596H65.1939C64.6544 42.7927 55.623 42.8396 54.8372 37.6671V41.0334H48.6091V37.6202C48.0695 40.9513 46.1577 41.4087 45.3249 41.4087C44.6212 41.4087 42.9088 40.834 42.2754 39.0746L42.334 40.9864C42.3458 42.1711 43.1082 42.9217 43.9057 43.0273V45.7836H36.6455V43.0156C37.2554 43.0038 38.2289 42.3939 38.2406 41.0685V36.0602C38.0178 37.3153 37.0912 41.3852 32.6224 41.3852C28.2006 41.3852 27.1919 37.0924 27.0042 36.459C26.1714 41.1389 23.0633 41.397 21.7027 41.3735C19.2513 41.3383 17.7735 39.6493 17.7383 39.6141C16.2604 38.1128 15.9789 35.8491 16.0376 33.3978C16.0376 32.9051 16.1666 31.9434 16.2135 31.4742C14.6301 33.1749 13.1522 32.9638 11.4046 33.0342H9.93848V35.8374C9.93848 36.9634 10.349 37.6319 11.604 37.6437V41.0099H2.97144V37.714C4.22644 37.7023 4.66042 36.9751 4.66042 35.8491V25.8677C4.66042 25.6331 4.60177 24.0849 2.98317 24.0732V20.8008H12.296C14.0554 20.8008 15.2986 21.3403 16.1431 21.9971C17.6914 23.217 18.008 25.3282 18.1371 26.8764C20.5063 24.8121 26.1245 24.3547 27.0746 30.5241C28.095 25.8208 31.5551 25.4689 32.3644 25.4572C33.8188 25.4572 36.3053 26.3369 37.1146 28.7179V25.7856H42.2168V27.674C42.5921 26.2548 43.8471 25.4807 45.1256 25.4689C46.3571 25.4572 48.8788 26.8295 49.5239 32.0255V25.1053C49.5239 24.1084 48.9023 23.5923 47.9053 23.5923V20.836H53.8402V32.0372C54.3798 27.0758 57.1478 25.4924 59.4819 25.4924C61.8511 25.4924 63.5284 26.806 64.3846 28.495C65.4871 30.6532 65.405 32.9403 65.3464 34.4182H58.1213C58.0979 34.6997 58.1213 35.1806 58.1448 35.6145C58.18 36.8344 58.5788 37.9486 59.5405 37.9369ZM21.82 37.9369C22.6058 37.9369 23.0163 37.2097 23.1805 36.2714H26.9456C26.7579 35.333 26.7344 35.1337 26.711 34.4065H20.3773C20.3539 34.6879 20.3773 35.1688 20.4008 35.6028C20.4594 36.8344 20.8582 37.9486 21.82 37.9369ZM31.039 33.4681C31.039 35.9547 31.4847 37.9603 32.6107 37.9721C33.7601 37.9838 34.1824 35.9547 34.1824 33.4681C34.1824 30.9816 33.7367 28.9759 32.6107 28.9642C31.5199 28.9407 31.039 30.9816 31.039 33.4681ZM21.7965 28.8704C20.8347 28.8704 20.4008 30.0433 20.3421 31.2748C20.3187 31.697 20.3187 31.7088 20.3421 32.0255H23.1923C23.2157 31.7088 23.2157 31.697 23.1923 31.2748C23.1336 30.0433 22.7583 28.8704 21.7965 28.8704ZM59.5171 28.9642C58.5553 28.9642 58.1565 30.0433 58.0861 31.2748C58.0627 31.697 58.0627 31.7088 58.0861 32.0255H60.9363C60.9597 31.7088 60.9597 31.697 60.9363 31.2748C60.8776 30.0433 60.4789 28.9642 59.5171 28.9642ZM42.4631 35.7318C42.4631 36.9868 42.768 37.9369 43.6477 37.9369C44.6329 37.9369 45.2194 36.6115 45.2194 33.4799C45.2194 30.0433 44.6916 28.8704 43.765 28.8352C42.8736 28.8 42.4161 29.5506 42.4631 31.1223V35.7318ZM9.93848 29.3043H11.1466C12.2374 29.2691 12.6244 28.6123 12.6244 26.9351C12.6244 25.4103 12.0849 24.6244 11.1466 24.6244H9.93848V29.3043Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_11789",
    x: -77.0286,
    y: -59.1992,
    width: 222.405,
    height: 184.982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_11789"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_11789",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_11789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeoplemag);
export default __webpack_public_path__ + "static/media/icon-peoplemag.eaab8e22afde929b1a9b3ce3a5b53746.svg";
export { ForwardRef as ReactComponent };